export const RENDER_MODE = {
    SIMPLE: 'simple',
    PRESENTATION: 'presentation',
};
